import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	checkboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	checkboxLabelGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	checkboxLabel: {
		id: 'issue-field-sprint.edit.menu.checkbox-label',
		defaultMessage: 'Only show sprints in this project ({projectKey})',
		description: 'Checkbox label. Allows to restrict Sprints in search results.',
	},
	checkboxLabelGalaxia: {
		id: 'issue-field-sprint.edit.menu.checkbox-label-galaxia',
		defaultMessage: 'Only show sprints in this space ({projectKey})',
		description: 'Checkbox label. Allows to restrict Sprints in search results.',
	},
});
export default messages;
